module.exports = __webpack_public_path__ + "public/images/program/program-23.ded1b7c8f7245045a42df15324da7222.jpg";